exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toolbar___14c8s {\n  height: 2.25rem;\n  padding: 0 0.5rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.Content___2Br59 {\n  padding: 0.5rem;\n  user-select: none;\n  border-top: 1px solid var(--color-border);\n  overflow: auto;\n}\n\n.Name___y3sqj {\n  font-size: var(--font-size-sans-large);\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.NothingSelected___LXwMm {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--color-dim);\n}\n\n.Commits___3dPiw {\n  font-weight: bold;\n}\n\n.List___1d-dx {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ListItem___6d_7z {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.25rem 0.5rem;\n}\n.ListItem___6d_7z:hover {\n  background-color: var(--color-background-hover);\n}\n\n.CommitBox___5r9ed {\n  width: 20px;\n  height: 20px;\n  margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"Toolbar": "Toolbar___14c8s",
	"Content": "Content___2Br59",
	"Name": "Name___y3sqj",
	"NothingSelected": "NothingSelected___LXwMm",
	"Commits": "Commits___3dPiw",
	"List": "List___1d-dx",
	"ListItem": "ListItem___6d_7z",
	"CommitBox": "CommitBox___5r9ed"
};